import _PHP from './_PHP';

const categories = ['essential', 'functional', 'performance', 'marketing'];

// old dwcc implementation

var cookieStatus = () => {
  var status = '0';
  if (window.cookieconsent && window.cookieconsent.getStatus) {
    var s = window.cookieconsent.getStatus();
    if (categories.indexOf(s) > -1) { status = s; }
  }
  else if (_PHP && _PHP.cookieConsent) {
    if (categories.indexOf(_PHP.cookieConsent) > -1) {
      status = _PHP.cookieConsent;
    }
  }
  return status;
};

export default cookieStatus;
